import React, {RefObject, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {CoreDoms, ViewMode, EditorExperienceType} from '@taopix/taopix-core';
import {PageInterface, ProductLayout} from '@taopix/taopix-core/dist/types/types';
import {PagesSelector} from '../../../Selectors';
import Page from '../../Page/Page';
import {useExperience} from '../../Experience/ExperienceProvider';
import PageToolbar from '../../Page/PageToolbar';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import classNames from 'classnames';
import PageName from '../../Page/PageName';
import {PageActionsProvider} from '../../Context/PageActions/PageActionsContext';

export interface SingleViewProps {
  layout: ProductLayout;
  containerRef: RefObject<HTMLElement>;
}

const SingleView = ({layout}: SingleViewProps) => {
  const {experience} = useExperience();
  const ui = useUiState();

  // get the pages from the store
  const pages = useSelector(PagesSelector);

  const tpxCoreAttrs = {
    [CoreDoms.ProjectPagesAttr]: 'true',
  };

  const editorType = useMemo(() => {
    return ui.state.canEditPageLayout ? EditorExperienceType.Normal : EditorExperienceType.Locked;
  }, [ui.state.canEditPageLayout]);

  const listItemClasses = classNames([
    'relative',
    'flex',
    'flex-col',
    'snap-center',
    'snap-always',
    'shrink-0',
  ]);

  const projectPagesClasses = classNames('!w-full', ui.state.zoomLevel === 100 && '!h-auto');

  return (
    <>
      <ul {...tpxCoreAttrs} className={projectPagesClasses} key={editorType}>
        {pages.map((page: PageInterface, index: number) => {
          return (
            <li
              data-id={page.pagenumber}
              className={listItemClasses}
              key={`singleview-${page.ref}`}
            >
              <Page
                page={page}
                layout={layout}
                editorType={editorType}
                viewMode={ViewMode.Single}
                showErrors={true}
                showEmptyBoxes={true}
              >
                {/** is this correct? Hiding the page name if the thumbnail bar is off */}
                {!experience.EDITOR.workArea.singlePage.pageThumbnailBar && (
                  <PageName page={page} layout={layout} />
                )}
              </Page>
            </li>
          );
        })}
      </ul>
      {experience.EDITOR.workArea.singlePage.pageActionButtons && (
        <PageActionsProvider>
          <PageToolbar pageNumber={ui.state.pageNumber} />
        </PageActionsProvider>
      )}
    </>
  );
};

export default SingleView;
